import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Logo from "./components/Logo";
import FluidAnimation from "./components/FluidAnimation";
import FolderList from "./components/FolderList";
import CircularText from "./components/CircularText";
import TopAudioPlayer from "./components/TopAudioPlayer";
import AudioVisualizer from "./components/AudioVisualizer";
import ThesisPage from "./components/ThesisPage";
import MobileNotice from "./components/MobileNotice";
import { images } from "./components/FluidAnimation";
import { AudioProvider } from "./context/AudioContext";
import GolfPage from "./components/golf/GolfPage";

function HomePage() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  // Add this to check for the global audio visualizer props
  const [visualizerProps, setVisualizerProps] = useState<{
    analyser: AnalyserNode | null;
    isPlaying: boolean;
  }>({ analyser: null, isPlaying: false });

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Check for updates to the global audio visualizer props
  useEffect(() => {
    if (isMobile) return; // Skip on mobile

    const checkForVisualizerProps = () => {
      // @ts-ignore - Reading from window
      if (window.audioVisualizerProps) {
        // @ts-ignore
        setVisualizerProps(window.audioVisualizerProps);
      }
    };

    // Check immediately and then set up interval
    checkForVisualizerProps();
    const interval = setInterval(checkForVisualizerProps, 100);

    return () => clearInterval(interval);
  }, [isMobile]);

  const handleRotateImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <div className="App">
      <MobileNotice />
      {!isMobile && <TopAudioPlayer />}
      {!isMobile && <CircularText />}
      <div className="hero-section">
        {/* Add the AudioVisualizer here, inside the hero section */}
        {!isMobile && visualizerProps.analyser && visualizerProps.isPlaying && (
          <AudioVisualizer
            analyser={visualizerProps.analyser}
            isPlaying={visualizerProps.isPlaying}
          />
        )}
        <FluidAnimation currentImageIndex={currentImageIndex} />
        <div className="mask mask-athens">
          <header className="App-header">
            <div className="logo-container">
              <Logo onRotateImage={handleRotateImage} />
            </div>
          </header>
        </div>
      </div>
      <div className="folder-section">
        <FolderList />
      </div>
    </div>
  );
}

function App() {
  return (
    <AudioProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/thesis" element={<ThesisPage />} />
          <Route path="/golf" element={<GolfPage />} />
        </Routes>
      </Router>
    </AudioProvider>
  );
}

export default App;
